import { AUDIT_ENTITY_TYPE_LABELS, entityTypeLabel } from '@clockwise/shared';

// The canonical entity-type → label map is shared with the API (it powers the
// server's "Deleted <type>" fallback too) and drift is guarded by an API test.
export { AUDIT_ENTITY_TYPE_LABELS, entityTypeLabel };

export const AUDIT_ENTITY_TYPE_OPTIONS: ReadonlyArray<{ value: string; label: string }> =
  Object.entries(AUDIT_ENTITY_TYPE_LABELS).map(([value, label]) => ({ value, label }));

/**
 * Audit entity types whose status transitions have an approval timeline worth
 * showing. Maps the audit `entityType` (plural) to the approvals framework's
 * `objectType` (singular, `approval_instances.object_type`).
 */
export const AUDIT_APPROVAL_OBJECT_TYPE: Record<string, string> = {
  timesheets: 'timesheet',
};
